import { render, staticRenderFns } from "./otherProperty.vue?vue&type=template&id=186767aa&scoped=true&"
import script from "./otherProperty.vue?vue&type=script&lang=js&"
export * from "./otherProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186767aa",
  null
  
)

export default component.exports